import React from 'react';
import { FieldDefinition } from './FieldRenderer';

interface DynamicTextareaFieldProps {
  field: FieldDefinition;
  value: any;
  onChange: (fieldKey: string, value: any) => void;
  error?: string;
  disabled?: boolean;
  isArabic: boolean;
}

const DynamicTextareaField: React.FC<DynamicTextareaFieldProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
  isArabic
}) => {
  const label = isArabic ? field.label_ar || field.label : field.label;
  const placeholder = isArabic ? field.placeholder_ar || field.placeholder : field.placeholder;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(field.key, e.target.value);
  };

  const applyValidationRules = () => {
    const rules: any = {};

    if (field.validation) {
      if (field.validation.minLength) {
        rules.minLength = field.validation.minLength;
      }
      if (field.validation.maxLength) {
        rules.maxLength = field.validation.maxLength;
      }
    }

    return rules;
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <textarea
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        required={field.required}
        rows={field.validation?.rows || 3}
        {...applyValidationRules()}
        className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${
          isArabic ? 'text-right' : 'text-left'
        }`}
        dir={isArabic ? 'rtl' : 'ltr'}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default DynamicTextareaField;